import { connect } from 'react-redux'

import { updateBooking, updateBookingChanges } from 'syft-acp-core/actions/bookings'

import { ListingBreakInput } from './ListingBreakInput'

const mapDispatchToProps = dispatch => ({
  onChange: ({ id, attr, val }) => {
    dispatch(updateBooking({ id, attr, val }))
    dispatch(updateBookingChanges({ id, attr, val }))
  },
})

export default connect(null, mapDispatchToProps)(ListingBreakInput)
